import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { Icon, } from '../Icon';
import { iconAlignments, sizes, } from './constants';
const iconSizes = {
    [sizes.large]: 'small',
    [sizes.medium]: 'extraSmall',
    [sizes.small]: 'extraSmall',
};
const spacingStyles = {
    [sizes.large]: theme.spacing.x2,
    [sizes.medium]: theme.spacing.base,
    [sizes.small]: theme.spacing.base,
};
const defaultProps = {
    iconAlignment: iconAlignments.left,
    loading: false,
    size: sizes.medium,
};
const ButtonIcon = ({ customIcon, iconAlignment = defaultProps.iconAlignment, iconType, loading = defaultProps.loading, size = defaultProps.size, hasText, }) => {
    const iconContainerStyles = useMemo(() => (css `
        display: inline-flex;
        margin-right: ${(hasText && iconAlignment === iconAlignments.left) ? spacingStyles[size] : 0};
        margin-left: ${(hasText && iconAlignment === iconAlignments.right) ? spacingStyles[size] : 0};

        ${loading && css `
          visibility: hidden;
        `}
      `), [
        hasText,
        iconAlignment,
        loading,
        size,
    ]);
    return (iconType
        ? (_jsx("span", Object.assign({ css: iconContainerStyles }, { children: iconType === 'custom'
                ? customIcon
                : (_jsx(Icon, { size: iconSizes[size], type: iconType })) })))
        : null);
};
const MemoizedButtonIcon = memo(ButtonIcon);
export { MemoizedButtonIcon as ButtonIcon };
